
export const product = [
    {   id:1,
        name: 'Watch Wave Lite',
        price: 2199,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/a6549acb-b075-4c3e-8ed3-9c9fcba32d42_400x.png?v=1625046216',
        category: 'watches',
        qty: 1,
        offPrice: 15
    },
    {   id:2,
        name: 'boAt Watch vertex',
        price: 2299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main_blue_295a504a-2ae2-4719-9400-263f453efddd_400x.png?v=1635140773',
        category: 'watches',
        qty: 1,
        offPrice:21

    },
    {   id:3,
        name: 'boAt Strom',
        price: 2599,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/a6549acb-b075-4c3e-8ed3-9c9fcba32d42_400x.png?v=1625046216',
        category: 'watches',
        qty: 1,
        offPrice:27
    },
    {   id:4,
        name: 'boAt Watch Extends',
        price: 3499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/xtend_black_400x.png?v=1650387008',
        category: 'watches',
        qty: 1,
        offPrice:32
    },
        {id: 5,
        name: 'BoAt Watch Iris',
        price: 3499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-blue_d6503e2e-e0b1-4c4e-af28-2164903baf9f_400x.png?v=1640237576',
        category: 'watches',
        qty: 1,
        offPrice:15
    },
    {   id:6,
        name: 'BoAt Watch Flash',
        price: 3499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/5752f5e4-89e0-4f84-b7fe-4d9f85771046_400x.png?v=1625157753',
        category: 'watches',
        qty: 1,
        offPrice:45
    },
    {   id:7,
        name: 'boAt Watch Mysiq',
        price: 3499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/Green_4_400x.png?v=1651215796',
        category: 'watches',
        qty: 1,
        offPrice:21
    },
    {   id:8,
        name: 'boAt 131 -Wireless Earbuds',
        price: 1199,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/32011675-2ad8-4b99-9787-895caf201d28_400x.png?v=1642405569',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:25
    },
    {   id:9,
        name: 'boAt Rockerz 333',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-img-R333-1_400x.png?v=1641801662',
        category: 'earphone',
         highlight: 'top pics',
        qty: 1,
        offPrice:37
    },
    {   id:10,
        name: 'Watch Wave Lite',
        price: 2199,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main_black_72207866-b34c-4b47-885d-998168d62245_600x.png?v=1648108781',
        category: 'earphone',
        highlight: 'top pics',
        qty: 1,
        offPrice:15
    },
    {   id:11,
        name: 'boAt Airdopes 115',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/115-main1_400x.png?v=1650530656',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:12
    },
    {   id:12,
        name: 'boAt Airdopes 121 ',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/airdopes-121-v2-blue_400x.png?v=1612765376',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:10
    },
    {   id:13,
        name: 'boAt Airdopes 141 ',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/grey_400x.png?v=1648723802',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:22
    },
    {   id:14,
        name: 'boAt Airdopes 441 ',
        price: 2499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/218997d1-3fe9-4a19-809c-94a8a2d05273_400x.png?v=1625045659',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:32
    },
    {   id:15,
        name: 'boAt Airdopes 402 ',
        price: 1699,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/402-main-img_400x.png?v=1630059242',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:21
    },
    {   id:16,
        name: 'boAt Airdopes 621 ',
        price: 2799,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-img_AD621_1_400x.png?v=1616230788',
        category: 'earbuds',
        highlight: 'top pics',
        qty: 1,
        offPrice:37
    },
    {   id:17,
        name: 'boAt Rockerz 245 v2',
        price: 899,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/245v2_main_2_400x.png?v=1627276367',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:18,
        name: 'boAt Rockerz 235 V2',
        price: 899,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/ed46e58c-9643-43e0-b350-9539d293aa51_400x.png?v=1625045114',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:19,
        name: 'boAt Rockerz 450 V2',
        price: 899,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/7499af44-9d7a-489c-80f0-51f7799289e4_400x.png?v=1625045491',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:20,
        name: 'boAt Rockerz 550 V2',
        price: 1599,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/0cfa4417-0213-4b49-b78e-0ae68aeb7057_400x.png?v=1625046144',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:21,
        name: 'boAt Rockerz 330',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main3_a08fff6a-7c3d-4663-9499-3421df127e94_400x.png?v=1641801688',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:22,
        name: 'boAt Rockerz 550',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/0d8d4561-6985-44ba-9e70-4998c40f4df3_d851f1e5-1237-440a-8703-ebf06d2810c5_400x.png?v=1646390147',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:23,
        name: 'boAt Rockerz 225',
        price: 1299,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/35ca6350-d6f3-4bc2-a742-01b2c88d80c4_32f4ee23-49e0-4671-a25c-d92c8e085785_400x.png?v=1646389952',
        category: 'wireless',
        highlight: 'top pics',
        qty: 1
    },
    {   id:24,
        name: 'boAt Bassheads 225',
        price: 359,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/c3d0fbbd-9479-4351-bf04-91136da2ae91_400x.png?v=1625046259',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:25,
        name: 'boAt Bassheads 103',
        price: 359,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/103blk_400x.png?v=1574927262',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:26,
        name: 'boAt Bassheads 102',
        price: 359,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/f87f98c3-9b52-4f7f-9ebe-dd10ee9517d9_400x.png?v=1633152280',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:27,
        name: 'boAt Bassheads 242',
        price: 449,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/7d635fe4-8c4c-4c4b-8c00-6065455dc608_400x.png?v=1625046386',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:28,
        name: 'boAt Bassheads 152',
        price: 449,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/6b1c2b0b-84b2-499f-a9e0-b25e66ce9b5f_400x.png?v=1625046597',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:29,
        name: 'boAt Bassheads 900',
        price: 599,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/08119dcb-d777-44af-b556-3492e5b4b7f0_400x.png?v=1625046271',
        category: 'wired',
        highlight: 'top pics',
        qty: 1
    },
    {   id:30,
        name: 'boAt Immortal 700',
        price: 2499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main2_33ed4e4f-8ef4-4c8a-a0c7-68216dfafa4a_300x.png?v=1643477993',
        category: 'wireless',
        highlight: 'gaming',
        qty: 1
    },
    {   id:31,
        name: 'boAt Immortal 1300',
        price: 3499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/IM1300_main_2_300x.png?v=1632715015',
        category: 'wireless',
        highlight: 'gaming',
        qty: 1
    },
    {   id:32,
        name: 'boAt Immortal 1000D',
        price: 2499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/2_f3aa2756-01f3-4e39-80bc-7b4f6551c7aa_300x.png?v=1625748159',
        category: 'wireless',
        highlight: 'gaming',
        qty: 1
    },
    {   id:33,
        name: 'boAt Immortal 400',
        price: 1999,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main2-700_300x.png?v=1643632679',
        category: 'wireless',
        highlight: 'gaming',
        qty: 1
    },
    {   id:34,
        name: 'boAt Immortal 200',
        price: 1499,
        img: 'https://cdn.shopify.com/s/files/1/0057/8938/4802/products/main-bl_400x.png?v=1625748090',
        category: 'wireless',
        highlight: 'gaming',
        qty: 1
    },
    
]